import React from 'react'
import { utcToLocalTime } from '../../../../../Studio-Services/Studio_Services';

export default function ParentInActivePurchasedPasses({
    purchaseRecurringInactiveCard, purchaseTimeFrameInactiveCard,
    purchasePunchInactiveCard, purchasePunchInactiveCardRecurring,
    studioData, changeStatus, changePassInfo, checkCardExpire
}) {
    const recurringInactiveCard = Array.isArray(purchaseRecurringInactiveCard) ? purchaseRecurringInactiveCard : [];
    const timeFrameInactiveCard = Array.isArray(purchaseTimeFrameInactiveCard) ? purchaseTimeFrameInactiveCard : [];
    const punchInactiveCard = Array.isArray(purchasePunchInactiveCard) ? purchasePunchInactiveCard : [];
    const punchInactiveCardRecurring = Array.isArray(purchasePunchInactiveCardRecurring) ? purchasePunchInactiveCardRecurring : [];

    return (
        <>
            <h4 className="title text-capitalize mt-5">In-Active Purchased Passes </h4>

            <h4 className="group_card mt-3">Recurring Membership</h4>
            {recurringInactiveCard.length > 0 &&
                <div className="row pt-4">
                    {recurringInactiveCard.map((lists) => (
                        <div className="col-md-6 col-lg-4 mt-3">
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">
                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.full_price} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} className="img-fluid" />
                                        </div>
                                    </div>

                                </div>
                                <div className="row mt-4">
                                    <div className="col-12">
                                        <p>Auto Renew</p>
                                        {/* <p>Remaining Days : {lists.remaining_count} of {lists.total_count}</p> */}
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-8">
                                        <p className="font-12">Start Date : {utcToLocalTime(lists.start_date_utc)} </p>
                                        {(lists.pass_cancellation_date == '') &&
                                            <div>
                                                <p className="font-12">Expiration Date : {utcToLocalTime(lists.end_date_utc)} </p>
                                            </div>
                                        }
                                        {lists.pass_cancellation_date != '' &&
                                            <div>
                                                <p className="font-12">Cancellation Date : {lists.pass_cancellation_date} </p>
                                            </div>
                                        }
                                    </div>
                                    <div className="col-4">
                                        {lists.is_recurring_stop == 0 &&
                                            <button className="btn btn-brandred text-right" onClick={() => changeStatus(1, lists.booking_pass_id, lists.pass_id, lists)}
                                            >Expired
                                            </button>
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {recurringInactiveCard.length == 0 && <div> <p className="text-center">No Records Found</p> </div>}

            {/* ************ SLIDER ************ */}

            <h4 className="group_card mt-3">Time Frame</h4>
            {timeFrameInactiveCard.length > 0 &&
                <div className="row pt-4" >
                    {timeFrameInactiveCard.map((lists) => (
                        <div className="col-md-6 col-lg-4 mt-3">
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">

                                    <div className="col-8">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} className="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-12">
                                        {/* <p>Remaining Days : {lists.remaining_count} of {lists.total_count} </p> */}
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                        <p className="font-12">Expiration Date :
                                            {utcToLocalTime(lists.end_date_utc)} <button type="button"
                                                className="fa fa-edit" data-toggle="modal"
                                                data-target="#passInfoModel"
                                                onClick={() => changePassInfo(lists)}
                                            ></button></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {timeFrameInactiveCard.length == 0 && <div>  <p className="text-center">No Records Found</p>  </div>}

            {/* ************* SLIDER *************** */}

            <h4 className="group_card mt-3">Punch Card</h4>
            {punchInactiveCard.length > 0 &&
                <div className="row pt-4" >
                    {punchInactiveCard.map((lists) => (
                        <div className="col-md-6 col-lg-4 mt-3">
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">

                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} className="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <p>Remaining Classes : {lists?.passes_remaining_count} of {lists?.passes_total_count}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoModel" className="fa fa-edit"
                                                onClick={() => { checkCardExpire(lists.end_date_utc) && changePassInfo(lists); }}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Expiration Date :{utcToLocalTime(lists.end_date_utc)}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoDateModel" className="fa fa-edit"
                                                onClick={() => changePassInfo(lists, 2)}
                                            ></button>

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {punchInactiveCard.length == 0 && <div> <p className="text-center">No Records Found</p> </div>}


            <h4 className="group_card mt-3">Recurring Punch Card</h4>
            {punchInactiveCardRecurring.length > 0 &&
                <div className="row pt-4" >
                    {punchInactiveCardRecurring.map((lists) => (
                        <div className="col-md-6 col-lg-4 mt-3">
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">

                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} className="img-fluid" />
                                        </div>
                                    </div>

                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <p>Remaining Classes : {lists.remaining_count} of {lists.total_count}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoModel" className="fa fa-edit"
                                                onClick={() => { checkCardExpire(lists?.end_date_utc) && changePassInfo(lists); }}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Expiration Date :{utcToLocalTime(lists?.end_date_utc)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {punchInactiveCardRecurring.length == 0 && <div> <p className="text-center">No Records Found</p> </div>}

        </>
    )
}
